import { get } from "./api_helper"

export const getSeasonAPI = params => get("admin/master/season/page", params)

export const getSeasonListAPI = () => get("admin/master/season/list")
